// Vela suggestions hook for the Chart of accounts.
// Returns { data, loading, error, refetch, dismiss } (dismiss removes one suggestion).

import { useCallback, useState } from "react";
import type { VelaSuggestion } from "../pages/Accounting/ChartOfAccounts/types";
import { DEFAULT_VELA_SUGGESTIONS } from "../pages/Accounting/ChartOfAccounts/constants";

interface Result {
  data: VelaSuggestion[];
  loading: boolean;
  error: Error | null;
  refetch: () => void;
  dismiss: (id: string) => void;
}

export function useVelaSuggestions(): Result {
  const [data, setData] = useState<VelaSuggestion[]>(DEFAULT_VELA_SUGGESTIONS);

  const refetch = useCallback(() => setData(DEFAULT_VELA_SUGGESTIONS), []);
  const dismiss = useCallback((id: string) => {
    setData((prev) => prev.filter((s) => s.id !== id));
  }, []);

  return { data, loading: false, error: null, refetch, dismiss };
}